import { render, staticRenderFns } from "./BackerCenterPaymentsTabs.vue?vue&type=template&id=f20718e0"
import script from "./BackerCenterPaymentsTabs.vue?vue&type=script&lang=js"
export * from "./BackerCenterPaymentsTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports